// export const BASE_API_URL = '//13.232.251.90:5222'
// export const BASE_API_URL = 'http://13.235.24.38:8051'
export const BASE_API_URL2 = 'https://dev1.money91.com'
// export const BASE_API_URL = 'https://test2.services-money91.com/api'
export const BASE_API_URL = 'https://yoga.services-money91.com/api'
// export const BASE_API_URL = 'https://odoo.services-money91.com' 
export const FILE_UPLOAD_URL = 'https://media.getzyk.com/uploadMediaFile/6'
 